import { twMerge } from 'tailwind-merge';

import { TRadioCardAdvanced } from '@/ui-kit/radio-card-advanced/RadioCardAdvanced.types';

export const RadioCardAdvanced = ({
  id,
  isSelected = false,
  isDisabled = false,
  value,
  handleChange,
  className,
  children,
}: TRadioCardAdvanced) => {
  const cardClassname = twMerge(
    'transition-shadow group flex flex-col items-start w-full min-w-[320px] max-w-[420px] rounded-400 bg-primary border-2 p-5 border-primary cursor-pointer',
    isSelected && 'shadow-100 border-secondary',
    isDisabled && 'cursor-auto !shadow-0',
    className,
  );

  return (
    <div id={id} className={cardClassname} onClick={() => handleChange(value)}>
      {children}
    </div>
  );
};
